var React = require('react');

function TabletBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M186.645,18.434c-0.003-13.851-4.651-18.431-18.698-18.432\r\n\tC118.051-0.001,68.157-0.002,18.26,0.004C4.717,0.006,0.005,4.719,0.004,18.271c-0.006,70.171-0.006,140.343,0,210.515\r\n\tc0.002,13.438,4.52,18.016,17.797,18.019c50.293,0.012,100.587,0.01,150.879,0.002c13.382-0.004,17.958-4.55,17.963-17.857\r\n\tc0.014-35.187,0.005-70.37,0.005-105.556C186.647,88.405,186.652,53.42,186.645,18.434z"}));
}

TabletBack.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"186.65px","height":"246.812px","viewBox":"0 0 186.65 246.812","enableBackground":"new 0 0 186.65 246.812","xmlSpace":"preserve"};

module.exports = TabletBack;

TabletBack.default = TabletBack;
